
export default {
  path: '',
  childRoutes: [],
};
